An applicationLibraryQuestion as returned by a draft, since it can have the responses a hirer selected.
This should match applicationLibraryQuestion but add selectedResponses.
